import { gql } from '__generated__';

const GetBillingForProjectQuery = gql(`
  query GetBillingForProject($id: ID!) {
    project(id: $id) {
      id
      minimum_service_fee
      maximum_service_fee
      service_fee_percentage
      pass_on_fee
      currency
      organisation_vat_number
      yearly_registrations_count
    }
  }
`);

export default GetBillingForProjectQuery;
